import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import qs from 'qs'
import {getDefaultLocation} from '../../../helpers/enrolment'
import {connect} from 'react-redux'
import Loading from '../../pages/Loading'
import {receiveSelectedCategory, receiveSelectedLocation, requestSelectedLocation} from '../../../actions/tiles'

const mapStateToProps = ({
                           courses: { selectedCourseCode, data },
                           course: { selectedCourse },
                           tiles: {selectedLocation: {isFetching}},
                         }) => {
  return {
    defaultLocation: selectedCourse.locationCd,
    isFetching: isFetching,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestSelectedLocation: () => {
      dispatch(requestSelectedLocation())
    },
    receiveSelectedLocation: locationName => {
      dispatch(receiveSelectedLocation(locationName))
    },
    receiveSelectedCategory: categoryName => {
      dispatch(receiveSelectedCategory(categoryName))
    }
  }
}

class DefaultTileFilters extends Component {
  componentDidMount() {
    let {location, category} = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    })

    // Set a default category
    if (category) {
      this.props.receiveSelectedCategory(category)
    }

    // Set a default location
    if (location) {
      this.props.receiveSelectedLocation(location)
    } else {
      this.props.requestSelectedLocation()

      getDefaultLocation(this.props.defaultLocation).then(defaultLocation => {
        this.props.receiveSelectedLocation(defaultLocation)
      })
    }
  }

  render() {
    if (this.props.isFetching) {
      return <Loading/>
    }

    return this.props.children
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DefaultTileFilters))
